import script from "./ListOfRequests.vue?vue&type=script&setup=true&lang=js"
export * from "./ListOfRequests.vue?vue&type=script&setup=true&lang=js"

import "./ListOfRequests.vue?vue&type=style&index=0&id=46d0b0b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-46d0b0b7"]])

export default __exports__